import LandingPageUpsellApp from '@/apps/LandingPageUpsellApp.vue'
import IconLoading from '@/icons/loading-dots.svg?raw'
import type { Product } from '@/lib/types/Product'
import { createApp } from 'vue'
import * as CartService from '../services/cart'

const initFragranceSwitcher = (element: HTMLButtonElement) => {
  const root = element.closest(
    '[data-starter-kit-landing-page-purchase-root]',
  ) as HTMLElement
  const fragranceOptions = root?.querySelectorAll(
    '[data-fragrance-option-index]',
  )

  fragranceOptions?.forEach((option, key) => {
    option.addEventListener('click', () => {
      fragranceOptions.forEach((o) => o.removeAttribute('data-selected'))
      option.setAttribute('data-selected', '')
      element.dataset.selectedProductIndex = key.toString()
      root.dataset.selectedProductIndex = key.toString()
    })
  })
}

export default function init() {
  document
    .querySelectorAll('[data-starter-kit-landing-page-purchase]')
    .forEach((el, i) => {
      const element = el as HTMLButtonElement | null
      if (element && element.dataset && element.dataset.productJson) {
        initFragranceSwitcher(element)
        const productJson = JSON.parse(element.dataset.productJson) as
          | Product
          | Product[]
        element.addEventListener('click', async () => {
          const product = Array.isArray(productJson)
            ? productJson[Number(element.dataset.selectedProductIndex) ?? 0]
            : productJson
          window.mixpanel.track('starter_kit_lp_purchase_click', {
            product,
            button_index: i,
          })
          el.classList.add('Button--loading')
          el.classList.add('Button--is-disabled')
          el.setAttribute('disabled', 'disabled')
          const loading = document.createElement('span')
          loading.classList.add('Button__Icon')
          loading.classList.add('Button__Icon--loading')
          loading.innerHTML = IconLoading
          el.textContent = ''
          el.appendChild(loading)
          await CartService.add({
            id: product.id,
            selectedVariantId: product.selectedVariantId.toString(),
            selectedSellingPlanId:
              product.variants[
                product.selectedVariantId
              ].sellingPlanAllocations[0]?.sellingPlan.id.toString(),
            quantity: 1,
          })
          if (product.lpUpsellProduct[0]) {
            const upsellProduct = product.lpUpsellProduct[0]
            const containerEl = document.createElement('div')
            document.body.appendChild(containerEl)
            const app = createApp(LandingPageUpsellApp, {
              product: upsellProduct,
            })
            app.mount(containerEl)
          } else {
            CartService.checkout()
          }
        })
      }
    })

  const stickyCtas = document.querySelectorAll('[data-starter-kit-sticky-cta]')
  const loop = () => {
    if (window.scrollY > 100) {
      stickyCtas.forEach((el) => el.classList.add('is-visible'))
    } else {
      stickyCtas.forEach((el) => el.classList.remove('is-visible'))
    }
    window.requestAnimationFrame(loop)
  }
  loop()

  document.addEventListener('DOMContentLoaded', function () {
    const beforeAfterContainers = document.querySelectorAll(
      '[data-before-after-handle]',
    )

    beforeAfterContainers.forEach((container) => {
      const handle = container as HTMLElement
      const beforeAfter = container.closest(
        '.Proof__BeforeAfter',
      ) as HTMLElement
      const beforeImage = beforeAfter?.querySelector(
        '.Proof__BeforeAfter__Image:first-child',
      ) as HTMLElement

      let isDragging = false
      let startX: number
      let startWidth: number

      // Mouse events
      handle.addEventListener('mousedown', startDrag)
      document.addEventListener('mousemove', drag)
      document.addEventListener('mouseup', stopDrag)

      // Touch events for mobile
      handle.addEventListener('touchstart', startDrag)
      document.addEventListener('touchmove', drag)
      document.addEventListener('touchend', stopDrag)

      function startDrag(e: Event) {
        isDragging = true
        startX =
          e.type === 'mousedown'
            ? (e as MouseEvent).clientX
            : (e as TouchEvent).touches[0].clientX
        startWidth = parseInt(getComputedStyle(handle).left)

        e.preventDefault()
      }

      function drag(e: Event) {
        if (!isDragging) return

        const currentX =
          e.type === 'mousemove'
            ? (e as MouseEvent).clientX
            : (e as TouchEvent).touches[0].clientX
        const deltaX = currentX - startX
        const containerWidth = beforeAfter.offsetWidth
        const newWidth = Math.max(
          0,
          Math.min(containerWidth, startWidth + deltaX),
        )

        // beforeImage.style.width = newWidth + 'px'
        beforeImage.style.clipPath = `rect(0 ${newWidth}px 100% 0)`
        handle.style.left = newWidth + 'px'

        e.preventDefault()
      }

      function stopDrag() {
        isDragging = false
      }
    })
  })
}
